import React from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";

const WhyOncq = () => {
  const { t } = useTranslation();
  return (
    <div className="headingmains text-center pb-5">
      <h2 className="right aos-init pb-2">{t("why_oncquest")}</h2>
      <h5 className="right aos-init pb-2">{t("­india's_leading_super_specialised­­")}</h5>
      <p className="once-par">{t("laboratory_network")}</p>
      <div className="row">
        <div className="col-lg-12">
          <div className="row whyOnq">
            <div className="col-sm-6 col-lg-3">
              <img src={t("images.home.whyOnq1")} alt="" />
              <h5>{t("poineer")}</h5>
              <p className="once-par">{t("22_years_of_diagnostic_excellence")}</p>
            </div>
            {/* <div className="col-sm-6 col-lg-3">
                  <img src={t("images.home.whyOnq2")} alt="" />
                  <h5>{t("comprehensive_test_menu")}</h5>
                </div> */}
            <div className="col-sm-6 col-lg-3">
              <img src={t("images.home.whyOnq9")} alt="" />
              <h5>{t("reliable")}</h5>
              <p className="once-par">{t("known_for_second_opinion_and_final_diagnosis")}</p>
            </div>
            <div className="col-sm-6 col-lg-3">
              <img src={t("images.home.whyOnq3")} alt="" />
              <h5>{t("accurate")}</h5>
              <p className="once-par">{t("state_of_the_art_technologies")}</p>
            </div>
            <div className="col-sm-6 col-lg-3">
              <img src={t("images.home.whyOnq4")} alt="" />
              <h5>{t("network_on")}</h5>
              <p className="once-par">{t("30_plus_labs_3000_plus_business_and_service_associates")}</p>
            </div>
            <div className="col-sm-6 col-lg-3">
              <img src={t("images.home.whyOnq5")} alt="" />
              <h5>{t("test_range")}</h5>
              <p className="once-par">{t("4000_plus_tests_and_packages_under_one_roof")}</p>
            </div>
            <div className="col-sm-6 col-lg-3">
              <img src={t("images.home.whyOnq6")} alt="" />
              <h5>{t("experience_on")}</h5>
              <p className="once-par">{t("600_plus_years_of_combined_clinical_experience")}</p>
            </div>
            <div className="col-sm-6 col-lg-3">
              <img src={t("images.home.whyOnq7")} alt="" />
              <h5>{t("accredition")}</h5>
              <p className="once-par">{t("nabl_lab")}</p>
            </div>
            <div className="col-sm-6 col-lg-3">
              <img src={t("images.home.whyOnq8")} alt="" />
              <h5>
                {t("lab_on_wheels")} 
              </h5>
              <p className="once-par">{t("home_sample")}</p>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-4 whyonqVdo">
              <ReactPlayer className="vdo" controls url={"https://www.youtube.com/watch?v=qUWlKp6n5qo"} light = {true} playing={true}/>
            </div> */}
      </div>
    </div>
  );
};

export default WhyOncq;
